import React from "react";
import { connect } from "react-redux";
import { setActiveVariation, toggleSizeDropdown } from "../../../../Redux/slices/singleProduct";

const mapDispatchToProps = dispatch => {
    return {
        setActiveVariation: payload => dispatch(setActiveVariation(payload)),
        toggleSizeDropdown: payload => dispatch(toggleSizeDropdown(payload))
    };
};

class SizeItem extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (this.props.stockStatus !== "OUT_OF_STOCK") {
            this.props.setActiveVariation({
                id: this.props.id,
                price: this.props.price,
                value: this.props.value
            });
            this.props.toggleSizeDropdown({ visible: false });
        }
    }

    render() {
        var soldOut = this.props.stockStatus === "OUT_OF_STOCK";

        return <div onClick={this.onClick} className={"size-item" + (soldOut ? " sold-out" : "")}>
            <div className="item-value">{this.props.value}</div>
            <div className="stock-status">{soldOut  ? "Sold out" : ""}</div>
        </div>
    }
}

export default connect(null, mapDispatchToProps)(SizeItem);